import cx from 'classnames'

import { Container } from './Container'

export const PageContent = ({ children, className, ...props }) => (
  <Container className={cx('tw:py-8 tw:mobile:py-6', className)} {...props}>{children}</Container>
)
